<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <strong>{{ $t('NEWMODULECATEGORY') }}</strong>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <b-form-fieldset v-bind:label="$t('NAME')">
                                <inputvalidation :formerror="formError" name="name">
                                    <b-form-input type="text" v-model="formData.name"
                                        v-bind:placeholder="$t('NAME')"></b-form-input>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-4">
                            <b-form-fieldset v-bind:label="$t('ORDERNUM')">
                                <inputvalidation :formerror="formError" name="orderNum">
                                    <b-form-input type="number" v-model="formData.orderNum"></b-form-input>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div slot="footer">
                        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">
                            {{ formError.notice }}
                        </p>
                        <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="save(formData)">
                            <i class="fa fa-dot-circle-o"></i> {{ $t('SUBMIT') }}
                        </b-button>
                    </div>
                </b-card>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> {{ $t('MODULECATEGORIES') }}
                    </div>
                    <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
                        <p class="center">{{ $t('NODATAFOUND') }}</p>
                    </div>
                    <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
                        <table class="table table-responsive-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{{ $t('NAME') }}</th>
                                    <th>{{ $t('ORDERNUM') }}</th>
                                    <th>{{ $t('SAVE') }}</th>
                                    <th>{{ $t('DELETE') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in data.root" :key="item.moduleCategoryId">
                                    <td>
                                        <b-form-input type="text" v-model="item.name"
                                            v-bind:placeholder="$t('NAME')"></b-form-input>
                                    </td>
                                    <td>
                                        <b-form-input type="number" v-model="item.orderNum"></b-form-input>
                                    </td>
                                    <td>
                                        <b-button size="sm" variant="primary" v-on:click.prevent="save(item)">
                                            {{ $t('SAVE') }}
                                        </b-button>
                                    </td>
                                    <td>
                                        <b-button size="sm" variant="danger"
                                            v-on:click.prevent="deleteRow(item.moduleCategoryId)">
                                            {{ $t('DELETE') }}
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '@/api/ModuleCategories';

export default
{
    name: 'ModuleCategories',
    data()
    {
        return {
            data: {},
            formError: {},
            formData: { name: '', orderNum: 0 },
            pagination: { currentPage: 1, limit: 200 },
        };
    },
    created()
    {
        this.getData();
    },
    methods:
    {
        async save(item)
        {
            const me = this;
            const params = { ...item };

            if (item.moduleCategoryId != null)
            {
                params.id = item.moduleCategoryId;
            }

            const data = await Api.save(params);

            if (data.error && data.error === true)
            {
                me.formError = data;
                me.$notify.notice(data);
                return;
            }

            me.formError = {};
            me.formData = { name: '', orderNum: 0 };
            me.$notify.notice(data);
            me.getData();
        },
        async getData()
        {
            const me = this;
            const data = await Api.selectRow({
                start: (me.pagination.currentPage - 1) * me.pagination.limit,
                limit: me.pagination.limit,
            });

            if (data.error && data.error === true)
            {
                me.$notify.notice(data);
                return;
            }

            me.data = data;
        },
        deleteRow(id)
        {
            const me = this;

            me.$store.commit('setModalAlert',
                {
                    // deleting a category only uncategorises its modules, the
                    // devices themselves are untouched - see the foreign key
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow({ id });

                        if (data.error && data.error === true)
                        {
                            me.$notify.error(data.notice);
                        }
                        else
                        {
                            me.$notify.success(data.notice);
                        }

                        me.getData();
                    },
                });
        },
    },
};
</script>
